// extracted by mini-css-extract-plugin
export var codeSnippet__caption = "code-snippet-block-module--code-snippet__caption--3e2ed";
export var codeSnippet__container = "code-snippet-block-module--code-snippet__container--0003d";
export var codeSnippet__copyCodeButton = "code-snippet-block-module--code-snippet__copy-code-button--db081";
export var codeSnippet__copyCodeSuccess = "code-snippet-block-module--code-snippet__copy-code--success--ed74d";
export var content = "code-snippet-block-module--content--428c5 text-content-module--wrapper--bdd0a";